import { Link } from "@gromia/components/Link";
import * as s from "@gromia/components/theme/t.module.css";
import cx from "classnames";
import { pipe } from "fp-ts/lib/function";
import * as O from "fp-ts/lib/Option";
import React from "react";

type FaqPreviewItemProps = {
  title: NonNullable<React.ReactNode>;
  children: NonNullable<React.ReactNode>;
  isOpen?: boolean;
  onIsOpenToggle?: () => void;
};

export function FaqPreviewItem(props: FaqPreviewItemProps) {
  return (
    <div
      className={cx(s.bgWhite, s.shadow, s.rounded, s.overflowHidden, s.mb2)}
    >
      <button
        className={cx(
          s.textDark,
          s.fontWeightBold,
          s.dFlex,
          s.justifyContentBetween,
          s.w100,
          s.appearanceNone,
          s.border0,
          s.pt4,
          s.pb4,
          s.pr5,
          s.pl5,
          s.bgTransparent,
          s.outlineNone,
        )}
        onClick={props.onIsOpenToggle}
      >
        <span className={cx(s.textLeft)}>{props.title}</span>
        <span className={cx(s.textPrimary)}>{props.isOpen ? "-" : "+"}</span>
      </button>
      {props.isOpen
        ? (
          <div className={cx(s.textMuted, s.textLeft, s.pb4, s.pl5, s.pr5)}>
            {props.children}
          </div>
        )
        : null}
    </div>
  );
}

type StepsProps = {
  seeAllCta?: NonNullable<React.ReactNode>;
  children: Array<React.ReactElement<FaqPreviewItemProps>>;
};

export function FaqPreview(props: StepsProps) {
  const [isOpen, setIsOpen] = React.useState<Array<boolean>>(
    React.Children.map(props.children, () => false),
  );

  function setIsOpenByIndex(idx: number) {
    return () => {
      let xs = [...isOpen];
      xs[idx] = !xs[idx];
      setIsOpen(xs);
    };
  }

  return (
    <div>
      <div>
        {React.Children.map(props.children, (x, index) =>
          React.cloneElement(x, {
            key: index,
            isOpen: isOpen[index],
            onIsOpenToggle: setIsOpenByIndex(index),
          }))}
      </div>
      {pipe(
        O.fromNullable(props.seeAllCta),
        O.fold(
          () => null,
          cta => (
            <div className={s.textRight}>
              <Link to="/faq">
                {cta}
                <span className={s.pl1}>→</span>
              </Link>
            </div>
          ),
        ),
      )}
    </div>
  );
}
